export default __webpack_public_path__ + "static/media/ecom.26d96e7e.svg";